import { Box, Checkbox, Flex, FormLabel, Heading } from '@chakra-ui/react'
import { useTranslation } from 'react-i18next';
import Card from 'shared/components/horizon-ui/card/Card';
import InfiniteTable from 'shared/components/table/InfiniteTable';
import useGetColors from 'shared/hooks/useGetColors';
import PageTitle from '../admin/PageTitle';
import { useGetColumns, useGetFilterFields, useGetGetBreadcrumbs } from './constants';
import { SubscriptionsT } from '../../api/types/subscriptions';
import { useGetSubscriptions as useGetSubscriptionsOrigin } from '../../api/requests/subscriptions';
import { TableNameE } from 'shared/api/types/common';
import { useState } from 'react';

const Index = () => {
  const { gray800 } = useGetColors();
  const { t } = useTranslation();
  const { blue800 } = useGetColors();
  const columns = useGetColumns();
  const breadcrumbs = useGetGetBreadcrumbs();
  const filterFields = useGetFilterFields();
  const [hasMessageAt, setHasMessageAt] = useState(false);

  const useGetSubscriptions = useGetSubscriptionsOrigin(hasMessageAt);

  return (
    <Box>
      <PageTitle title={t('subscriptions.subscriptions')} breadcrumbs={breadcrumbs} />
      <Card mb="20px" borderRadius="20px" px="30px">
        <Flex alignItems="center" marginBottom={5}>
          <Heading size="md" color={blue800}>
            {t('subscriptions.subscriptionsTable')}
          </Heading>
          <Flex ml={5} alignItems="center">
            <Checkbox
              id='hasMessageAt'
              onChange={(e) => setHasMessageAt(e.target.checked)}
              colorScheme="brandScheme"
              me="10px"
              checked={hasMessageAt}
            />
            <FormLabel
              htmlFor="hasMessageAt"
              mb="0"
              fontWeight={500}
              color={gray800}
              fontSize="md"
            >
              {t("Show only messaged")}
            </FormLabel>
          </Flex>
        </Flex>
        <InfiniteTable<SubscriptionsT>
          query={useGetSubscriptions}
          columns={columns}
          filterFields={filterFields}
          tableName={TableNameE.SUBSCRIPTIONS}
        />
      </Card>
    </Box>
  );
};

export default Index;
